import Flickity from 'flickity';
import _debounce from 'lodash/debounce';
import { getRTL } from './_utils';
import { updateCookie } from '../../../../design3/asset-build/js/custom/paginatedFilter';

const baseClass = 'FindMeetingVenueWizard';
const hiddenClass = `${baseClass}-page--hidden`;
const multiSelectClass = `${baseClass}-page-buttons--multiSelect`;
const activeButtonClass = `${baseClass}-wizardButton-button--active`;
const inactiveButtonClass = `${baseClass}-wizardButton-button--inactive`;
const classes = {
	uninitializedContainer: `FindMeetingVenueWizard--uninitialized`,
};
const selectors = {
	container: `.${baseClass}`,
	list: `.${baseClass}-list`,
	page: `.${baseClass}-page`,
	hiddenPage: `.${hiddenClass}`,
	buttonContainer: `.${baseClass}-page-buttons`,
	button: `.${baseClass}-wizardButton-button`,
	activeButton: `.${activeButtonClass}`,
	skipButton: `.${baseClass}-page-navigation-skipButton`,
	navigationButton: `.${baseClass}-page-navigation-button`,
	previousButton: `.${baseClass}-page-navigation-previousButton`,
	nextButton: `.${baseClass}-page-navigation-nextButton`,
	nextCta: `.${baseClass}-page-navigation-nextCta`,
};

let wizardPages = [];
let flickity;

const initNextCta = $container => {
	$container.find(selectors.nextCta).click(function (e) {
		e.preventDefault();
		let activeButtons = $container.find(selectors.activeButton);
		let filterGroups = {};
		let activeFeatures = [];
		activeButtons.each((index, button) => {
			let filterGroup = $(button).closest(selectors.buttonContainer).data('filterGroup');
			let filterId = $(button).data('filterId');
			let filterValue = $(button).data('filterValue');

			if (filterValue) {
				filterGroups[filterGroup] = filterGroups[filterGroup] || { filters: [] };

				if (filterGroup === 'featureFilters') {
					activeFeatures.push(filterValue);
				} else {
					filterGroups[filterGroup].filters.push({ id: filterId, value: filterValue });
				}
			}
		});
		if (activeFeatures.length) {
			filterGroups['featureFilters'].filters.push({ id: 'features', value: activeFeatures });
		}
		updateCookie({ filterGroups }, 'paginatedFilter-property-finder');
		window.location = $(this).attr('href');
	});
};

const initSelectionButtons = $container => {
	$container.find(selectors.button).click(function () {
		handleButtonClick($(this));
	});
};

const handleButtonClick = $button => {
	let $buttonContainer = $button.closest(selectors.buttonContainer);
	let buttons = $buttonContainer.find(selectors.button);
	let multiSelect = $buttonContainer.hasClass(multiSelectClass);

	if ($button.hasClass(activeButtonClass)) {
		$button.removeClass(activeButtonClass);
		if (!multiSelect) {
			$(buttons).removeClass(inactiveButtonClass);
		}
	} else {
		if (!multiSelect) {
			$(buttons).addClass(inactiveButtonClass);
			$(buttons).removeClass(activeButtonClass);
		}
		$button.removeClass(inactiveButtonClass);
		$button.addClass(activeButtonClass);
	}
};

const initCarousel = $container => {
	const $list = $container.children(selectors.carouselList);
	const nextButton = $container.find(selectors.nextButton);
	const prevButton = $container.find(selectors.previousButton);
	const $carousel = $list.get(0);

	$container.addClass(`${baseClass}--flickity`);

	flickity = new Flickity($carousel, getOptions());
	wizardPages.push({ flickity, $container });
	$carousel.removeAttribute('tabIndex');

	nextButton.on('click.flickity', () => {
		flickity.next();
	});
	prevButton.on('click.flickity', () => {
		flickity.previous();
	});

	return flickity;
};

const getOptions = () => {
	return {
		cellAlign: 'center',
		pageDots: false,
		prevNextButtons: false,
		rightToLeft: getRTL(),
		wrapAround: false,
		selectedAttraction: 0.05,
		friction: 0.8,
		draggable: false,
		adaptiveHeight: true,
	};
};

const onFocusIn = (flickity, index) => {
	if (flickity && index) {
		flickity.select(index);
	}
};

export default function init() {
	$(selectors.container).each((index, container) => {
		let $container = $(container);

		let flickity = initCarousel($container);
		$container.removeClass(classes.uninitializedContainer);

		initSelectionButtons($container);

		initNextCta($container);

		let $pages = $container.find('.WizardPage');
		$pages.each(function (index, page) {
			const $page = $(page);
			$page.focusin(
				(() => {
					return function (e) {
						onFocusIn(flickity, index);
					};
				})()
			);
		});
	});
}
